import { render, staticRenderFns } from "./epms5070.vue?vue&type=template&id=57d2352c&scoped=true"
import script from "./epms5070.vue?vue&type=script&lang=js"
export * from "./epms5070.vue?vue&type=script&lang=js"
import style0 from "./epms5070.vue?vue&type=style&index=0&id=57d2352c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2352c",
  null
  
)

export default component.exports